import type { QueryClient } from "@tanstack/react-query";

import type { OpportunityListId } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

import { getOpportunityListTableQueryKeys } from "./queryKeyFactory";

/**
 * List table queries use `staleTime: Infinity` and `keepPreviousData`, so `invalidateQueries` still
 * renders the previous rows until refetch completes. Drop the cache so the next visit loads fresh data.
 */
export const clearOpportunityListQueries = (queryClient: QueryClient, listId?: OpportunityListId): void => {
    getOpportunityListTableQueryKeys(listId).forEach((queryKey) => {
        queryClient.removeQueries({ queryKey });
    });
};
